const EndedArrowDown = () => (
  <>
    <path
      fill="currentColor"
      d="M5.5 20a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.357q0-.212.144-.356A.49.49 0 0 1 5.5 19h13q.212 0 .356.144a.49.49 0 0 1 .144.357q0 .212-.144.356A.48.48 0 0 1 18.5 20zm6.498-4.021a.8.8 0 0 1-.296-.053.8.8 0 0 1-.268-.184l-3.388-3.388a.5.5 0 0 1-.15-.344.47.47 0 0 1 .15-.364.5.5 0 0 1 .354-.16.5.5 0 0 1 .354.16l2.746 2.746V4.5q0-.213.144-.356A.49.49 0 0 1 12.001 4q.212 0 .356.144a.49.49 0 0 1 .143.356v9.892l2.746-2.746a.5.5 0 0 1 .345-.15.47.47 0 0 1 .363.15.5.5 0 0 1 .16.354.5.5 0 0 1-.16.354l-3.389 3.388a.8.8 0 0 1-.27.184.8.8 0 0 1-.297.053"
    />
  </>
)
export default EndedArrowDown
